import { useEffect, useState } from 'react';
import { User } from './types/User';
import Tabs from '../Tabs';
import CampaignTable from './tables/CampaignTable';
import {
    fetchCampaignsOfUser,
    fetchInitialCampaignRequestsOfUser,
} from '~/services/users';
import CampaignRequestTable from './tables/CampaignRequestTable';

interface Props {
    user: User;
}

const TeamMemberTabs: React.FC<Props> = ({ user }) => {
    const [openTab, setOpenTab] = useState(1);
    const [campaigns, setCampaigns] = useState([]);
    const [initialCampaigns, setInitialCampaigns] = useState([]);

    const tabs = [
        { name: 'Campaigns', count: campaigns.length },
        { name: 'Campaign Requests as Initial Contact', count: initialCampaigns.length },
    ];
    const fetchAndSetInitialCampaign = async () => {
        const initialCampaignResponse =
            await fetchInitialCampaignRequestsOfUser({ user_id: user?.id });
        setInitialCampaigns(initialCampaignResponse.results);
    };

    const fetchAndSetCampaign = async () => {
        const campaignResponse = await fetchCampaignsOfUser({
            user_id: user?.id,
        });
        setCampaigns(campaignResponse.results);
    };
    useEffect(() => {
        fetchAndSetCampaign();
        fetchAndSetInitialCampaign();
    }, []);

    return (
        <>
            <Tabs tabNames={tabs} openTab={openTab} setOpenTab={setOpenTab}>
                {openTab == 1 && <CampaignTable campaigns={campaigns} />}
                {openTab == 2 && (
                    <CampaignRequestTable campaigns={initialCampaigns} />
                )}
            </Tabs>
        </>
    );
};

export default TeamMemberTabs;
